
import { LoadCategories } from '../../../util/Enum';
export default {
  props: {
    filterProp: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      loadTypes: {
        isUrgent: false,
        isReadyNow: false,
        isRecent: false,
      },
    };
  },
  watch: {
    filterProp: {
      handler() {
          this.loadTypes = this.filterProp
          this.$emit('value-changed', this.filterProp)

      },
      deep: true,
      immediate: true
    },
    loadTypes : {
      handler() {
        this.handleChange();
        },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChange () {
      this.$emit('value-changed', this.loadTypes)
      
    },
   getValueString(){
      const selectedTypes = (Object.keys(this.loadTypes).filter((key)=>this.loadTypes[key])).map((e)=>e.split('is')[1].split(/(?=[A-Z])/).join(' '))
      return selectedTypes.length === 0 ? 'Any': selectedTypes.join(' , ')
   }
  }
}
